import { Component, OnInit } from '@angular/core';
import { Http, Headers, Response,RequestOptions} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { User } from '../_models/index';
import { UserService } from '../_services/index';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-ref-program',
  templateUrl: './ref-program.component.html',
  styleUrls: ['./ref-program.component.css']
})
export class RefProgramComponent implements OnInit {
  getdata:any;
  backendUrl:any;
  constructor(private http: Http) { }

  ngOnInit() {
     let url=window.location.hostname;
    //  if(url=='app.foodbot.ai' || url=='dashboard.foodbot.ai'){this.backendUrl=environment.prod}
    //  else if(url=='stage.foodbot.ai'){ this.backendUrl=environment.stage}
    //  else if(url=='uat.foodbot.ai'){ this.backendUrl=environment.uat}  
    //  else{ this.backendUrl=environment.local}
    if (url == 'app.foodbot.ai' || url == 'dashboard.foodbot.ai') { this.backendUrl = environment.prod } else if (url == 'stage.foodbot.ai') { this.backendUrl = environment.stage } 
    else if (url == 'uat.foodbot.ai') { this.backendUrl = environment.uat } 
    else if (url == '127.0.0.1') { this.backendUrl = environment.local } 
    else { 
      this.backendUrl=window.location.origin
      this.backendUrl+="/apis"
    }

  	var sql="SELECT count(a.sender_id)cnt,a.sender_id,a.date_time,b.first_name,b.last_name FROM fb_user_session a left join fb_user_profiles b on a.sender_id=b.sender_id where a.page_id='1846909518858139' group by date(a.date_time),a.sender_id ORDER BY a.date_time DESC";
  	 let headers = new Headers ({  'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers, method: "post" });
        
        return this.http.post(this.backendUrl+'/getdata',JSON.stringify({'query': sql}),options)
            .map(data => data.json())
            .subscribe(data => {
          this.getdata = data;
          console.log("I CANT SEE DATA HERE: ", this.getdata);
        });
  }

}



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/ref-program/ref-program.component.ts